export const RouteConstants = {
    ONBOARDING: 'onboarding',
    INCREMENTAL_ONBOARDING: 'incremental_onboarding',
    INCREMENTAL_ONBOARDING_EDIT: 'incremental_onboarding_edit',
    PAYMENT_PROFILE: 'payment_profile',
    ADMIN: 'admin',
    ADMIN_ACTIONS: 'admin_actions',
    ADMIN_ACTION_DETAIL: 'admin_action_detail',
    PROFILE: 'profile',
    COMPLIANCE_FORM_DETAILS: 'compliance_form_details',
    ONBOARDING_STATUS: 'onboarding_status',
    ONBOARDING_SUCCESS: 'onboarding_success',
    ONBOARDING_UPLOAD_DOCUMENTS: 'onboarding_upload_documents',
    ONBOARDING_EDIT_OWNER_INFO: 'onboarding_edit_owner_info',
    ONBOARDING_EDIT_BUSINESS_INFORMATION: 'onboarding_edit_business_information',
    ONBOARDING_EDIT_BANK_ACCOUNT: 'onboarding_edit_bank_account',
    ONBOARDING_EDIT_BUSINESS_STRUCTURE: 'onboarding_edit_business_structure',
    ERROR: 'error',
    DUPLICATE: 'duplicate',
    DASHBOARD: 'dashboard',
    TRANSACTIONS: 'transactions',
    AUTHORIZATIONS : 'authorizations',
    DEPOSITS: 'deposits',
    DEPOSITS_OLD: 'deposits_old',
    DISPUTES: 'disputes',
    DISPUTE_DETAILS: 'dispute_details',
    TRANSACTION_DETAILS: 'transaction_details',
    AUTHORIZATION_DETAILS : 'authorization_details',
    DEPOSIT_DETAILS: 'deposit_details',
    DEPOSIT_DETAILS_OLD: 'deposit_details_old',
    DISPUTE_RESPONSE: 'dispute_response',
    LOGIN: 'login',
    LOGOUT: 'logout',
    DEFAULT: 'default',
    EXPORTS: 'exports',
    REPORTS: 'reports',
    NOTIFICATIONS: 'notifications',
    ADD_FUNDS: 'add_funds',
    SETUP_PROGRESS: 'setup_progress',
    INCREMENTAL_ONBOARDING_ADD_BANK_ACCOUNT: 'incremental_onboarding_add_bank_account',
    INVOICES: 'invoices',
    BALANCE_RESERVE: 'balance_reserve',
}